// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 POST /app/common/archiveInactiveReports */
export async function archiveInactiveReportsAsync(options?: {
  [key: string]: any;
}) {
  return request<any>('/app/common/archiveInactiveReports', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 DELETE /app/common/deleteFile */
export async function deleteFileAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DeleteFileAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/deleteFile', {
    method: 'DELETE',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/downloadFile */
export async function downloadFileAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DownloadFileAsyncParams,
  options?: { [key: string]: any },
) {
  return request<string>('/app/common/downloadFile', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/generateReportData */
export async function generateReportData(options?: { [key: string]: any }) {
  return request<any>('/app/common/generateReportData', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getAppList */
export async function getAppListAsync(options?: { [key: string]: any }) {
  return request<any>('/app/common/getAppList', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getApproverList */
export async function getApproverList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetApproverListParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getApproverList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getBasicMotorInfo */
export async function getBasicMotorInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetBasicMotorInfoParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getBasicMotorInfo', {
    method: 'GET',
    params: {
      // seriesId has a default value: -1
      seriesId: '-1',
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getBasicMotorSeries */
export async function getBasicMotorSeriesAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetBasicMotorSeriesAsyncParams,
  options?: { [key: string]: any },
) {
  return request<API.BasicMotorSeriesDto[]>('/app/common/getBasicMotorSeries', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getCalcSymbol */
export async function getCalcSymbol(options?: { [key: string]: any }) {
  return request<any>('/app/common/getCalcSymbol', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getCustomerList */
export async function getCustomerListAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetCustomerListAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getCustomerList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getCustomerType */
export async function getCustomerType(options?: { [key: string]: any }) {
  return request<any>('/app/common/getCustomerType', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getDictList */
export async function getDictListAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetDictListAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getDictList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getDivisionList */
export async function getDivisionListAsync(options?: { [key: string]: any }) {
  return request<any>('/app/common/getDivisionList', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getFormStatus */
export async function getFormStatus(options?: { [key: string]: any }) {
  return request<any>('/app/common/getFormStatus', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getFrameSize */
export async function getFrameSizeAsync(options?: { [key: string]: any }) {
  return request<any>('/app/common/getFrameSize', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getFrontCondition */
export async function getFrontCondition(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetFrontConditionParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getFrontCondition', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getIndustryList */
export async function getIndustryListAsync(options?: { [key: string]: any }) {
  return request<any>('/app/common/getIndustryList', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getJudgement */
export async function getJudgement(options?: { [key: string]: any }) {
  return request<any>('/app/common/getJudgement', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getReportUrl */
export async function getReportUrl(options?: { [key: string]: any }) {
  return request<string>('/app/common/getReportUrl', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getReservedFeild */
export async function getReservedFeild(options?: { [key: string]: any }) {
  return request<any>('/app/common/getReservedFeild', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getRuleIndicator */
export async function getRuleIndicator(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetRuleIndicatorParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getRuleIndicator', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getStatus */
export async function getStatus(options?: { [key: string]: any }) {
  return request<any>('/app/common/getStatus', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/common/getSubCustomerList */
export async function getSubCustomerListAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetSubCustomerListAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/getSubCustomerList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/matchRulesAndBusinessModel */
export async function matchRulesAndBusinessModel(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.MatchRulesAndBusinessModelParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/matchRulesAndBusinessModel', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/parsingParquet */
export async function parsingParquet(
  body: {},
  file?: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData();

  if (file) {
    formData.append('file', file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: 'application/json' }),
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<any>('/app/common/parsingParquet', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/rebateRuleCheckResult */
export async function rebateRuleCheckResultAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RebateRuleCheckResultAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/rebateRuleCheckResult', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/receivePmsInfo */
export async function receivePmsInfoAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ReceivePmsInfoAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/receivePmsInfo', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/resolveRebateModelData */
export async function resolveRebateModelDataAsync(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ResolveRebateModelDataAsyncParams,
  options?: { [key: string]: any },
) {
  return request<any>('/app/common/resolveRebateModelData', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/common/uploadFile */
export async function uploadFileAsync(
  body: {},
  file?: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData();

  if (file) {
    formData.append('file', file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: 'application/json' }),
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<string>('/app/common/uploadFile', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}
